import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_BASE } from '../api-base.token';
import { Topic } from './topic.model';
import { CreateTopicRequest } from './create-topic-request.model';
import { CreateToolboxTalkRequest } from './create-toolbox-talk-request.model';
import { AttendeeTrainingSummary } from './attendee-training-summary.model';
import { ToolboxTalkPagedResult } from './toolbox-talk-paged-result.model';

const path = 'toolbox-talks';

@Injectable({
  providedIn: 'root',
})
export class ToolboxTalksHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  createTopic(request: CreateTopicRequest) {
    const url = Location.joinWithSlash(this.apiBase, path + '/topics');
    return this.httpClient.post(url, request);
  }

  createToolboxTalk(request: CreateToolboxTalkRequest) {
    const url = Location.joinWithSlash(this.apiBase, `${path}`);
    return this.httpClient.post(url, request);
  }

  getToolboxTalks(params?: {
    page?: number;
    pageSize?: number;
    search?: string;
    fromDate?: string;
    toDate?: string;
  }) {
    const url = Location.joinWithSlash(this.apiBase, `${path}`);
    return this.httpClient.get<ToolboxTalkPagedResult>(url, { params });
  }

  getTopics() {
    const url = Location.joinWithSlash(this.apiBase, `${path}/topics`);
    return this.httpClient.get<Topic[]>(url);
  }

  getAttendees() {
    const url = Location.joinWithSlash(this.apiBase, `${path}/attendees`);
    return this.httpClient.get<AttendeeTrainingSummary[]>(url);
  }

  removeAttendee(toolboxTalkId: string, memberId: string) {
    const url = Location.joinWithSlash(
      this.apiBase,
      `${path}/attendees/${toolboxTalkId}/${memberId}`
    );
    return this.httpClient.delete(url);
  }

  deleteTopic(topicId: string) {
    const url = Location.joinWithSlash(
      this.apiBase,
      `${path}/topics/${topicId}`
    );
    return this.httpClient.delete(url);
  }
}
